export default __webpack_public_path__ + "static/media/Eye-Icon.f2ee5ab4.svg";